import { render, staticRenderFns } from "./AddSquad.vue?vue&type=template&id=8ae1e184"
import script from "./AddSquad.vue?vue&type=script&lang=js"
export * from "./AddSquad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports